import uuid from 'uuid/v4';

function key(prefix?: string): string {
  if (prefix) {
    return `${prefix}_${uuid()}`;
  }

  return uuid();
}

export default key;
